var React = require('react');

function ExclamationMark (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#081319;}")),React.createElement("path",{"d":"M15.6,12.23,15.5,9.5h3l-.1,2.73L18,18.5H16Z","key":1}),React.createElement("circle",{"cx":"17","cy":"22","r":"1.5","key":2}),React.createElement("path",{"d":"M17,1A16,16,0,1,0,33,17,16,16,0,0,0,17,1Zm0,31A15,15,0,1,1,32,17,15,15,0,0,1,17,32Z","key":3})]);
}

ExclamationMark.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = ExclamationMark;

ExclamationMark.default = ExclamationMark;
